module.exports = __webpack_public_path__ + "img/log.79c19290.svg";